(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unaluna-bundle-test"] && !Shopify.designMode) return;
  try {
    
function unalunaResolveBundle(nativeVariants, components, color, size) {
  const beddingSizes = {
    '60x40x11': '140x200 cm + 46x66 cm',
    '70x40x12': '140x200 cm + 46x73 cm',
    '70x40x15': '140x200 cm + 46x73 cm'
  };
  if (!color || !beddingSizes[size]) return null;
  const native = nativeVariants.find(variant => variant.options.includes(color) && variant.options.includes(size));
  const bedding = components.bedding.find(variant => variant.options.includes(color) && variant.options.includes(beddingSizes[size]));
  const pillow = components.pillow.find(variant => variant.title === size);
  if (!native || !bedding || !pillow) return null;
  return { native, bedding, pillow, available: native.available && bedding.available && pillow.available };
}

function unalunaInitializeBundle(root) {
  if (root.dataset.bundleInitialized === 'true') return;
  const form = root.querySelector('.ub-form');
  const variantsElement = root.querySelector('[data-bundle-stock-variants]');
  const componentsElement = root.querySelector('[data-bundle-components]');
  if (!form || !variantsElement || !componentsElement) return;
  root.dataset.bundleInitialized = 'true';
  const nativeVariants = JSON.parse(variantsElement.textContent);
  const components = JSON.parse(componentsElement.textContent);
  const colorInputs = [...form.querySelectorAll('[data-component="bedding"]')];
  const sizeInputs = [...form.querySelectorAll('[data-component="pillow"]')];
  const stockNode = root.querySelector('[data-bundle-stock]');
  const button = form.querySelector('[type="submit"]');
  const error = form.querySelector('[data-error]');
  const nativeInput = form.querySelector('[data-native-id]');
  const formatter = new Intl.NumberFormat(root.dataset.locale || 'da-DK', { style: 'currency', currency: root.dataset.currency || 'DKK' });
  const findCombination = (color, size) => unalunaResolveBundle(nativeVariants, components, color, size);
  let submitting = false;
  const quantityInput = form.querySelector('[data-bundle-quantity]');
  form.querySelectorAll('[data-quantity-change]').forEach(control => {
    control.addEventListener('click', () => {
      const current = Number(quantityInput.value);
      const safeCurrent = Number.isInteger(current) && current >= 1 ? current : 1;
      quantityInput.value = String(Math.max(1, safeCurrent + Number(control.dataset.quantityChange)));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  root.querySelectorAll('[data-gallery-src]').forEach(thumbnail => thumbnail.addEventListener('click', () => {
    const hero = root.querySelector('.ub-hero');
    hero.removeAttribute('srcset');
    hero.src = thumbnail.dataset.gallerySrc;
    hero.alt = thumbnail.dataset.galleryAlt;
    root.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === thumbnail)));
  }));
  const updateTrust = () => {
    if (Date.now() > Date.parse('2026-10-31T22:59:00Z')) return;
    root.querySelectorAll('span').forEach(el => {
      if (el.textContent.trim() === 'Fri fragt over 600 kr.') el.textContent = root.dataset.currentShippingLabel;
    });
  };
  updateTrust();
  new MutationObserver(updateTrust).observe(root, { childList: true, subtree: true });

  const syncStock = (combination, complete) => {
    const label = document.createElement('p');
    label.className = 'ul-stock__label';
    const delivery = document.createElement('p');
    delivery.className = 'ul-stock__delivery';
    if (!complete) label.textContent = stockNode.dataset.choose;
    else if (!combination || !combination.available) label.textContent = stockNode.dataset.soldOut;
    else if (combination.native.tracked && combination.native.quantity > 0) {
      const dot = document.createElement('span');
      dot.className = 'ul-stock__dot';
      dot.setAttribute('aria-hidden', 'true');
      label.append(dot, document.createTextNode(stockNode.dataset.inStock));
      delivery.textContent = stockNode.dataset.delivery;
    } else label.textContent = combination.native.tracked ? stockNode.dataset.backorder : stockNode.dataset.available;
    stockNode.replaceChildren(label);
    if (delivery.textContent) stockNode.append(delivery);
    button.disabled = submitting || !combination || !combination.available;
  };

  const syncVariant = () => {
    const color = colorInputs.find(input => input.checked)?.value;
    const size = sizeInputs.find(input => input.checked)?.value;
    const combination = findCombination(color, size);
    nativeInput.value = combination?.available ? String(combination.native.id) : '';
    form.querySelector('[data-pillow-id]').value = combination?.available ? String(combination.pillow.id) : '';
    form.querySelector('[data-bedding-id]').value = combination?.available ? String(combination.bedding.id) : '';
    const coverSize = size === '60x40x11' ? '46 × 66' : '46 × 73';
    if (size) root.querySelector('[data-pillowcase-size]').textContent = coverSize;
    root.querySelector('[data-bedding-color]').textContent = color ? ' · ' + color : '';
    root.querySelectorAll('[data-bundle-pillow-text]').forEach(el => {
      if (size) el.textContent = size.replaceAll('x', ' × ') + ' cm';
    });
    root.querySelectorAll('[data-bundle-pillowcase-text]').forEach(el => {
      if (size) el.textContent = coverSize + ' cm' + (color ? ' · ' + color : '');
    });
    colorInputs.forEach(input => {
      input.disabled = size ? !findCombination(input.value, size)?.available : !sizeInputs.some(item => findCombination(input.value, item.value)?.available);
    });
    sizeInputs.forEach(input => {
      input.disabled = color ? !findCombination(color, input.value)?.available : !colorInputs.some(item => findCombination(item.value, input.value)?.available);
    });
    if (combination) {
      root.querySelector('[data-price]').textContent = formatter.format(combination.native.price / 100);
      if (root.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(combination.native.id));
        window.history.replaceState(window.history.state, '', url);
      }
    }
    syncStock(combination, Boolean(color && size));
    return combination;
  };

  const initialVariant = nativeVariants.find(variant => String(variant.id) === root.dataset.initialVariant);
  if (initialVariant) {
    [...colorInputs, ...sizeInputs].forEach(input => { input.checked = initialVariant.options.includes(input.value); });
  } else {
    const preferredSizes = [...sizeInputs].sort((a, b) => Number(b.value === '60x40x11') - Number(a.value === '60x40x11'));
    const defaultCombination = preferredSizes.flatMap(sizeInput => colorInputs.map(colorInput => findCombination(colorInput.value, sizeInput.value))).find(combination => combination?.available);
    if (defaultCombination) {
      [...colorInputs, ...sizeInputs].forEach(input => { input.checked = defaultCombination.native.options.includes(input.value); });
    }
  }
  form.addEventListener('change', () => { error.hidden = true; syncVariant(); });
  syncVariant();

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting || !form.reportValidity()) return;
    const combination = syncVariant();
    if (!combination?.available || !nativeInput.value) return;
    submitting = true;
    button.disabled = true;
    error.hidden = true;
    try {
      const response = await fetch(form.action + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error('cart');
      window.location.assign(root.dataset.cartUrl);
    } catch {
      submitting = false;
      error.hidden = false;
      syncVariant();
    }
  });
}

document.querySelectorAll('.ub').forEach(unalunaInitializeBundle);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.ub').forEach(unalunaInitializeBundle);
});

  } catch(e) { console.error(e); }
})();
})();
